import { createReducer, on } from '@ngrx/store';
import { User } from '../../user/models/user.model';
import { adminActionTypes } from './admin.actions';

export interface AdminState {
  isFetching: boolean;
  admins: {
    count: number;
    data: User[];
  };
}

export const initialState: AdminState = {
  isFetching: false,
  admins: {
    count: 0,
    data: [],
  },
};

export const adminReducer = createReducer(
  initialState,
  on(adminActionTypes.fetchAdminsRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(adminActionTypes.fetchAdminsSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      admins: action.admins,
    };
  }),
  on(adminActionTypes.fetchAdminsFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  }),
  on(adminActionTypes.createAdminsRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(adminActionTypes.createAdminsSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      admins: {
        count: state.admins.count,
        data: [...state.admins.data, action.admin],
      },
    };
  }),
  on(adminActionTypes.createAdminsFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  }),
  on(adminActionTypes.deleteAdminsRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(adminActionTypes.deleteAdminsSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      admins: {
        count: state.admins.count,
        data: state.admins.data.filter(u => !action.ids.includes(u.id))
      },
    };
  }),
  on(adminActionTypes.deleteAdminsFailure, (state) => {
    return {
      ...state,
      isFetching: false,
    };
  })
);
